<i class="material-icons" istag="icon">{{ icon }}</i>
